module.exports = __webpack_public_path__ + "static/media/fraction-addition.043aa83d.svg";